import { gql } from '@apollo/client'

export const PROCESSINGS_EXPORT_TASKS_QUERY = gql`
  query processingsExportTasks(
    $sortBy: ProcessingsExportTaskSort
    $filter: ProcessingsExportTaskFilter
    $limit: Int
  ) {
    processingsExportTasks(sortBy: $sortBy, filter: $filter, limit: $limit) {
      collection {
        id
        createdAt
        hasDownloaded
        documentUrl
        hasErrors
        userId
        status
      }
    }
  }
`
